var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionCheckbox',{attrs:{"checked":_vm.omitYear},on:{"check":_vm.removeYear,"uncheck":_vm.addYear}},[_vm._v("\n\t"+_vm._s(_vm.t('contacts', 'Omit year'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }